import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import DyzioModal from 'dyzio-shared-components/lib/components/dyzio-modal';
import ReepayCard from '../../components/reepay-card';
import OrganisationSettings from '../../components/organisation-settings';
import ThemeSelector from '../../themes/theme-selector';

const REEPAY_PLANS = {
  premium: 'https://dyzio.reepay.com/3521307b5322ffc7b379683d6944a698',
  proteam: 'https://dyzio.reepay.com/2cddaf93f6e2b4c06d824b2eb7414217',
};

const spacedOut = {
  marginBottom: 50,
};

class SettingsTab extends React.Component {
  constructor() {
    super();
    this.state = {
      modalOpen: false,
    };
  }

  toggleCancelModal = () => {
    this.setState({
      modalOpen: !this.state.modalOpen,
    });
  }


  openReepayWindow = plan => {
    const planUrl = REEPAY_PLANS[plan];
    window.open(planUrl, '_blank');
  };

  render() {
    const { modalOpen } = this.state;
    const { isFullWhiteLabel } = ThemeSelector.theme();
    const { organisation } = this.props;
    const handleOrganisationChange = _.get(this.props, 'children.handleOrganisationChange', _.noop);
    const licenseSubscriptionType = _.get(organisation, 'licenseSubscriptionType', null);
    const fetchOrganisation = _.get(this.props, 'children.fetchOrganisation', _.noop);
    return (
      <div>
        {
          !isFullWhiteLabel && <div style={spacedOut}>
            <ReepayCard
              onButtonClick={this.openReepayWindow}
              licenseSubscriptionType={licenseSubscriptionType}
              toggleCancelModal={this.toggleCancelModal}
            />
          </div>
        }
        {
          modalOpen &&
          <DyzioModal
            headerText="Cancel Subscription"
            size="small"
            onClose={this.toggleCancelModal}
          >
            Send an email to <a href="mailto:payments@dyzio.co">payments@dyzio.co</a> to cancel your subscription.
            Alternatively, use the
            <a onClick={() => this.toggleCancelModal() || window.Intercom('show')}>
              {' Intercom '}
            </a>
            button at the bottom right of your screen to contact us,
            and we will arrange cancellation.
          </DyzioModal>
        }

        <div style={spacedOut}>
          <OrganisationSettings
            organisation={organisation}
            onChange={handleOrganisationChange}
            fetchOrganisation={fetchOrganisation}
          />
        </div>
      </div>
    );
  }
}

SettingsTab.propTypes = {
  organisation: PropTypes.object.isRequired,
};

export default SettingsTab;



/** WEBPACK FOOTER **
 ** ./src/containers/team-manager/settings-tab.js
 **/